module.exports = __webpack_public_path__ + "jefferson.jpg?b65a763e1ea2afdbf3f693ef10b2495f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jefferson.jpg
// module id = 19
// module chunks = 0